var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remark/3.1.1-\\u623F\\u8CB8\\u7522\\u54C1-\\u5167\\u9801",
    transform: "translate(-219.000000, -565.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(220.000000, 566.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5806452,11.2903226 C22.5806452,12.1806452 21.8580645,12.9032258 20.9677419,12.9032258 C20.0774194,12.9032258 19.3548387,12.1806452 19.3548387,11.2903226 C19.3548387,10.4 20.0774194,9.67741935 20.9677419,9.67741935 C21.8580645,9.67741935 22.5806452,10.4 22.5806452,11.2903226",
    id: "Fill-1",
    fill: "#A17D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6451613,11.2903226 C30.6451613,12.1806452 29.9225806,12.9032258 29.0322581,12.9032258 C28.1419355,12.9032258 27.4193548,12.1806452 27.4193548,11.2903226 C27.4193548,10.4 28.1419355,9.67741935 29.0322581,9.67741935 C29.9225806,9.67741935 30.6451613,10.4 30.6451613,11.2903226",
    id: "Fill-3",
    fill: "#A17D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3225806,15.3225806 C40.3225806,23.7846774 33.4620968,30.6451613 25,30.6451613 C16.5379032,30.6451613 9.67741935,23.7846774 9.67741935,15.3225806 C9.67741935,6.86048387 16.5379032,0 25,0 C33.4620968,0 40.3225806,6.86048387 40.3225806,15.3225806 Z",
    id: "Stroke-5",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9855645,19.3548387 C30.5912097,21.7653226 27.9847581,23.3870968 25.0000806,23.3870968 C22.0137903,23.3870968 19.4073387,21.7645161 18.0129839,19.3524194",
    id: "Stroke-7",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8709677,33.0645161 C33.8709677,33.9548387 33.1483871,34.6774194 32.2580645,34.6774194 C31.3677419,34.6774194 30.6451613,33.9548387 30.6451613,33.0645161 C30.6451613,32.1741935 31.3677419,31.4516129 32.2580645,31.4516129 C33.1483871,31.4516129 33.8709677,32.1741935 33.8709677,33.0645161",
    id: "Fill-1",
    fill: "#A17D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9354839,33.0645161 C41.9354839,33.9548387 41.2129032,34.6774194 40.3225806,34.6774194 C39.4322581,34.6774194 38.7096774,33.9548387 38.7096774,33.0645161 C38.7096774,32.1741935 39.4322581,31.4516129 40.3225806,31.4516129 C41.2129032,31.4516129 41.9354839,32.1741935 41.9354839,33.0645161",
    id: "Fill-3",
    fill: "#A17D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0048387,40.3269343 C41.7714391,42.2541651 39.4658592,43.5508065 36.8257134,43.5508065 C34.1841408,43.5508065 31.8785609,42.2535203 30.6451613,40.325",
    id: "Stroke-7",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4241935,40.324515 C19.1907939,42.2517457 16.885214,43.5483871 14.2450682,43.5483871 C11.6034957,43.5483871 9.29791577,42.251101 8.06451613,40.3225806",
    id: "Stroke-7",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5487903,24.6574194 C47.4229839,27.08 50.0004032,31.3840323 50.0004032,36.2904839 C50.0004032,43.8614516 43.8616935,50.0001613 36.2907258,50.0001613 C33.6245968,50.0001613 31.1366935,49.238871 29.0318548,47.9235484",
    id: "Stroke-13",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2903226,33.0645161 C11.2903226,33.9548387 10.5677419,34.6774194 9.67741935,34.6774194 C8.78709677,34.6774194 8.06451613,33.9548387 8.06451613,33.0645161 C8.06451613,32.1741935 8.78709677,31.4516129 9.67741935,31.4516129 C10.5677419,31.4516129 11.2903226,32.1741935 11.2903226,33.0645161",
    id: "Fill-17",
    fill: "#A17D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3548387,33.0645161 C19.3548387,33.9548387 18.6322581,34.6774194 17.7419355,34.6774194 C16.8516129,34.6774194 16.1290323,33.9548387 16.1290323,33.0645161 C16.1290323,32.1741935 16.8516129,31.4516129 17.7419355,31.4516129 C18.6322581,31.4516129 19.3548387,32.1741935 19.3548387,33.0645161",
    id: "Fill-19",
    fill: "#A17D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4193548,36.2903226 C27.4193548,43.8620968 21.2814516,50 13.7096774,50 C6.13790323,50 0,43.8620968 0,36.2903226 C0,31.383871 2.57741935,27.0798387 6.4516129,24.6572581",
    id: "Stroke-21",
    stroke: "#A17D58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon1);
export default __webpack_public_path__ + "static/media/product-icon1.058bbab2a1ba712a16396c6e369bd9ce.svg";
export { ForwardRef as ReactComponent };